import React from "react";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import { LanguageConstants } from "../../constants/LanguageConstants";

const CommanPhoneNumber = ({ value, handleMobileNumber }: any) => {
    const handlePhone = (value: any, code: any) => {
        const regex = new RegExp(code?.dialCode)
        const phone = value.replace(regex, "");
        handleMobileNumber(value, code, phone)
    }
    return (
        <>
            <div className="com-mobile-input com-floating">
                <label className="mobile-label f-label">{LanguageConstants?.PHONE_NUMBER} <span className="must-star"></span></label>
                <PhoneInput
                    inputClass="f-input w-100"
                    placeholder=""
                    disableInitialCountryGuess={false}
                    enableLongNumbers={false}
                    country={"us"}
                    countryCodeEditable={false}
                    value={value}
                    // value={${('phone_country_code')}${('phone_number')}}
                    onChange={handlePhone}
                    inputProps={{
                         disabled: true, 
                     }}
                />
                {/* <input className="mobile-label" type="text" /> */}
            </div>
        </>
    )
}

export default CommanPhoneNumber;
